import { useContext } from "react"
import { TLOContext } from "web/contexts"
import { useCurrentUser } from "web/hooks/data"

export default function useCurrentTLO() {
  const tloContext = useContext(TLOContext) || {}
  const currentUser = useCurrentUser()

  const { data, subjectType } = tloContext

  function userCan(action, childResource) {
    if (childResource !== undefined) {
      return (
        data.user_permissions[childResource] &&
        data.user_permissions[childResource][action]
      )
    }

    if (action in data.user_permissions) {
      return data.user_permissions[action]
    }

    return currentUser.can(action, subjectType)
  }

  const userCannot = (action, childResource) => !userCan(action, childResource)

  if (data === undefined) return undefined
  return { ...tloContext, userCan, userCannot }
}
